import React, { useState } from 'react';
import { Eye, EyeOff, AlertCircle, Loader2, ShieldAlert, ArrowLeft } from 'lucide-react';
import superAdminApi from '../services/superAdminApi';
import '../styles/super-admin-login.css';

function SuperAdminLogin({ onLogin, onBack }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await superAdminApi.login(username, password);
      onLogin(user);
    } catch (err) {
      setError(err.message || 'SuperAdmin login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sa-login-root">
      {onBack && (
        <button className="sa-back-link" onClick={onBack}>
          <ArrowLeft size={16} />
          Back to Home
        </button>
      )}

      <div className="sa-login-card">
        <div className="sa-login-header">
          <div className="sa-login-icon">
            <ShieldAlert size={32} strokeWidth={2} />
          </div>
          <h2>SuperAdmin Portal</h2>
          <p>Restricted access for system administrators only</p>
        </div>

        {error && (
          <div className="sa-login-error" role="alert">
            <AlertCircle size={18} />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="sa-login-form">
          <div className="sa-login-field">
            <label htmlFor="sa-username">Username or Email</label>
            <input
              id="sa-username"
              type="text"
              placeholder="admin@system.local"
              autoComplete="username"
              required
              value={username}
              onChange={e => setUsername(e.target.value)}
              disabled={loading}
              className="sa-login-input"
            />
          </div>

          <div className="sa-login-field">
            <label htmlFor="sa-password">Password</label>
            <div className="sa-login-input-wrap">
              <input
                id="sa-password"
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                autoComplete="current-password"
                required
                value={password}
                onChange={e => setPassword(e.target.value)}
                disabled={loading}
                className="sa-login-input"
              />
              <button
                type="button"
                className="sa-pw-toggle"
                onClick={() => setShowPassword(v => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button type="submit" className="sa-login-submit" disabled={loading}>
            {loading ? (
              <><Loader2 size={18} className="sa-spin" /><span>Authenticating...</span></>
            ) : (
              <span>Secure Login</span>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default SuperAdminLogin;
